export default {
  pageTitle: "FOIRE AUX QUESTIONS",
  menu: {
    menu1: 'Company and services',
    menu2: 'Understand the product and taste it',
    menu3: 'Orders and deliveries',
    menu4: 'Pricing policy',
  },
  services: {
    title: 'Company and services',
    tabList: {
      boires: 'Boires',
      ressourcesHumaines: 'Human ressources',
      producteurs: 'Producers',
      services: 'Services',
    },
    boires: [
      {
        question: 'What does Boires mean?',
        answer: 'BOIRES [bwaʁ] n.m. : Slang, neologism, French Canadian lingo inspired from the word drinks. Referred to when describing thirst-quenching liquids, more notably, the wines promoted by our agency.'
      },
      {
        question: 'What is a representative agency?',
        answer: ''
      },
      {
        question: 'What is the philosophy of the agency?',
        answer: ''
      },
      {
        question: 'How do I contact a representative?',
        answer: 'The best way to contact us is by email to <a href="mailto:info@boires.ca">info@boires.ca</a>. <br>Please include the following information:<br>Last name and first name:<br>Mailing address:<br>Phone number:'
      },
      {
        question: 'I have a specific request, who can I contact?',
        answer: 'The best way to contact us is by email to <a href="mailto:info@boires.ca">info@boires.ca</a>.<br>Please include the following information:<br>Last name and first name:<br>Mailing address:<br>Phone number:'
      }
    ],
    ressources: [
      {
        question: 'I would like to be part of the Boires team',
        answer: 'Awesome! Please send your resume and cover letter to <a href="mailto:info@boires.ca">info@boires.ca</a>'
      },
    ],
    producteurs: [
      {
        question: 'How do you choose your producers?',
        answer: ''
      },
    ],
    services: [
      {
        question: 'What is a private importation?',
        answer: 'Private importation is a way of ordering alcoholic beverages that are not available at SAQ stores. Whether you are a restaurateur, a business or a private client, you can easily get these exceptional items through our agency. Private import products are sold by the case and the number of bottles per case varies by product. This information is indicated on our lists or it can be found directly on our site by searching by product.'
      },
      {
        question: 'Does my SAQ Inspire card work with you?',
        answer: 'The inspire card only works for products sold in SAQ stores. It does not apply to products sold through private import.'
      },
      {
        question: 'Can I taste at the shop?',
        answer: 'Tastings are organized by appointment. For all tasting requests, please contact <a href="mailto:info@boires.ca">info@boires.ca</a>'
      },
      {
        question: 'Do you sell non-alcoholic drinks?',
        answer: ''
      },
      {
        question: 'What is the difference between a subscription and membership?',
        answer: ''
      },
      {
        question: 'What is the difference between the agency and the store?',
        answer: ''
      },
      {
        question: 'Do you have gift sets? ',
        answer: ''
      },
      {
        question: 'Do you have gift cards?',
        answer: ''
      },
    ],
  },
  understandProduct: {
    title: 'Understand the product',
    tabList: {
      tasteWine: 'Understand the product',
      jargon: 'Jargon',
    },
    tasteWine: [
      {
        question: 'How do I know if my wine is corked?',
        answer: 'If you smell an unpleasant odour of wet cardboard, dust, or fungus which becomes more pronounced with aeration, there is no doubt that your wine is corked.'
      },
      {
        question: 'Why does my wine smell like a farm? ',
        answer: 'The farm smell is usually associated with reductive style winemaking. It\'s completely natural and it should fade after a good decanting.'
      },
      {
        question: 'What is the difference between an oxidized wine and an oxidative wine?',
        answer: 'An oxidative wine is deliberately aged in contact with a small amount of oxygen that protects it from further oxidation. This style of wine can give pleasent aromas of hazelnuts, baked apple and dried fruit. An oxidized wine is a faulty wine. It is usually recognized by aromas of peanuts, oil or rancid butter that mask any fruity aromas. Oxidized wines may also show a change in colour that is towards orange or brown, regardless of the original color of the wine.'
      },
      {
        question: 'Is it normal for my wine to fizz?',
        answer: 'Sometimes the winemaker decides to leave CO2 in order to protect the wine when they want to minimize the amount of sulfur. This corbonation usually goes away after decanting or aerating. It is possible that a still wine may sparkle as much as a sparkling wine. In this case, it means that fermentation has resumed in your bottle because there was some sugar left in the wine when bottling. Don\'t panic, the wine is still good to drink.'
      },
      {
        question: 'My wine has deposits, is that normal?',
        answer: 'There may be a natural deposit in your wine. This does not affect the quality or taste of the wine. If you prefer clear and transparent wines, gently handle your bottle and keep it upright before pouring, the deposits should fall to the bottom.'
      },
      {
        question: 'Can I keep a natural wine?',
        answer: 'Of course! Some wines are great when aged in the cellar. The most important thing is to respect certain conditions which are: a stable temperature below 15 ° C, a humidity level above 60%, darkness, no vibrations, and a room without strong odors.'
      },
      {
        question: 'My wine froze, is it still good?',
        answer: 'Your wine is still drinkable and safe, but a tartaric precipitate will probably be created (small transparent crystals). The wine may have lost acidity and its aging will be compromised. Watch out for broken glass!'
      },
      {
        question: 'I left my wine in the heat, is it still good?',
        answer: 'Under the effect of heat, the wine may leak from the bottle causing oxidation. It is advisable to drink it as soon as possible if it is not already too late.'
      },
      {
        question: 'I have a very old wine, how can I open it without damaging the cork?',
        answer: 'The best way is to use a two prong type corkscrew that allows you to remove the cork along the walls of the neck, without damaging the cork that has become more fragile with age.'
      },
      {
        question: 'What is the ideal temperature to keep my wine?',
        answer: 'The ideal storage temperature is around 12-13 degrees. The most important thing is to avoid extreme temperatures and sudden changes in temperature.'
      },
      {
        question: 'Which glass should I use? ',
        answer: 'It is best to use a glass with a stem, made of crystal or glass with a relatively thin bowl. The chalice (the container) must be flared to allow reasonable ventilation. Several types of glasses are possible, all depending on the wine you drink. But no matter the glass, wine is best consumed in good company.'
      },
      {
        question: 'Should I decant my bottle?',
        answer: 'Certain whites, reds, rosés and even sparkling wines benefit from time in a carafe to develop their aromas. However, not all wines are suited and may risk having their qualities altered with aeration or decanting. If you\'re unsure on whether to decant or not, the best thing to do is ask your Boires representative.'
      },
      {
        question: 'Why is my wine cloudy?',
        answer: 'This usually means that the wine has not been filtered or fined. This does not remove any olfactory or taste quality, and even allows your wine to be more resistant over time.'
      },
    ],
    jargon: [
      {
        question: 'Reduction',
        answer: 'Does your wine have an aroma of rotten egg or cabbage? This is a result of reduction. A little air exposure with a decanter will do the trick.'
      },
      {
        question: 'Organic Wine',
        answer: 'Wine made from grapes from certified organic viticulture (without pesticides or herbicides and according to the specifications of the certification company). The use of inputs during winemaking is limited.'
      },
      {
        question: 'Biodynamic wine',
        answer: 'Holistic viticulture which aims to strengthen the vitality and resistance of the plant through the application of preventive homeopathic treatments, under a precise lunar calendar. Althouhg there\'s more to it than that. For more info: <a href="https://www.demetercanada.ca/what-is-biodynamic-agriculture/">https://www.demetercanada.ca/what-is-biodynamic-agriculture</a>'
      },
      {
        question: 'Natural wine',
        answer: 'Haaaaa the big question! There are no official specifications on what a natural wine is, but here is our opinion: The grapes necessarily come from organic or biodynamic viticulture, certified or not. No technological manipulation is allowed in vinification, apart from tiny doses of sulfur'
      },
      {
        question: 'Conventional wine - contemporary - chemical',
        answer: 'Wines from automated viticulture and using chemical fertilizers and phytosanitary products (herbicides, pesticides, etc.). Vinification is based on synthetic oenological inputs (acidification, sugar, selected yeasts, etc.) in order to to have a product that is always equal and controlled.'
      },
      {
        question: 'Filtration',
        answer: 'Filtration is a winemaking technique that aims to remove solid particles in the wine. It is used to make the wine clear and limpid and to eliminate potentially active bacteria in order to stabilize the wines. Fermented juices are passed through a filter medium which captures most of the particles.'
      },
      {
        question: 'Fining',
        answer: 'Fining is a winemaking technique that aims to clarify wines. A protein substance (egg white, fish albumin, beef blood, etc.) is introduced into the fermented juices, which will rush to the bottom of the tank and carry with it the molecules responsible for the cloudy appearance of the wines.'
      },
      {
        question: 'Orange wine',
        answer: 'An orange wine is a white wine with skin maceration. Similar to red wine, the juices are left to macerate in contact with the skins of the grapes. The skins give the wine a more or less orange color depending on their original pigments and offer more or less significant tannins depending on the grape variety and the maceration time.'
      },
      {
        question: 'Gobbledygook wine',
        answer: 'A refreshing wine that can be drank with big gulps, at any time of the day. Bottled to share with friends until the wee hours of the morning.'
      },
      {
        question: 'Oxidative wine',
        answer: 'This is said of a wine that was deliberately oxygenated during vinification, thus modifying its aromas (very ripe apples, spices, hazelnuts and walnuts). The best known are the Jura Vin Jaunes wines and Spanish Sherry.'
      },
      {
        question: 'Sustainable agriculture',
        answer: 'Conventional cultural approach in which the producer tries to reduce the use of sythesis products. Some hide behind this term and treat their vines systemically, while others have a sincere approach and make intense efforts to limit the use of processed products.'
      },
      {
        question: 'Clean wine',
        answer: 'Organic, biodynamic, natural wines, the primary objective is respect for biodiversity. The use of chemicals, harmful to the environment, is abandoned with the aim of producing vintages that reflect their original terroir.'
      },
      {
        question: 'Permaculture',
        answer: 'Permaculture aims to develop agricultural systems, based on the diversity of crops, their resilience and natural productivity. By leaving room for other species of plants, trees, beehives and animals to eat certain pests, weeds and produce natural fertilizer.'
      },
      {
        question: 'Sulphur',
        answer: 'Whether it is of volcanic origin or derived from petroleum (sulfur dioxide), sulfur is used in wine for two reasons. It acts as an antioxidant and antiseptic, stabilizing and stopping bacterial growth in wine. It is also used in many food products, such as dried fruits that contain much higher amounts than that found in wine.'
      },
      {
        question: 'Volatile',
        answer: 'Volatile acid, which includes ethyl acetate (nail polish aroma) and acetic acid (vinegar) is present in all wines at a level of at least 0.2g / l. In moderate doses, it brings freshness to the wine, but can bring vinegar aromas when too high.'
      },
      {
        question: 'Aging',
        answer: 'Aging is the process that will allow the wine to pass from a raw stage, just after alcoholic fermentation, to one where it becomes pleasant to drink. The winemaker according to his style and / or his culture and his specifications, can choose to age his wines in different containers (barrel, stainless steel or concrete vat, amphora ...)'
      },
      {
        question: 'Terroir',
        answer: 'Terroir is commonly perceived as the soil from which the vines are grown in. In a broader sense, terroir is actually made up of the soil, the cultivated grape variety, the climate specific to the region and the cultural practices of the person who cultivates it.'
      },
      {
        question: 'Micro-brewery',
        answer: 'Although there is no formal definition of this term, it is used to describe a new generation of small breweries specializing in the production of beers, unfiltered and unpasteurized.'
      },
      {
        question: 'Microdistillery',
        answer: 'A microdistillery or artisanal distillery is a place of manufacture, in limited quantities, of spirits obtained by distillation.'
      },
      {
        question: 'From grain to bottle',
        answer: 'Expression used to qualify spirits made from grain, not from neutral alcohol purchased as raw material from an industrial distillery. According to this standard, the artisanal distillery must process the grain itself to obtain the alcohol that will be bottled.'
      },
      {
        question: 'Fermentation',
        answer: 'Fermentation is the biochemical process by which sugars are transformed into alcohol thanks to yeasts (whether indigenous or selected).'
      },
      {
        question: 'Selected yeasts',
        answer: 'Excessive use of chemicals in the vineyard tends to decrease the population of native yeasts naturally present on grapes. To ensure that fermentation begins, producers of conventional wines must use chemical (or selected) yeasts to ensure the fermentation of their wines.  A variety of selected yeasts are available on the market, easily recognizable by their distinctive aromas.'
      },
      {
        question: 'Native yeasts',
        answer: 'Ambient yeasts that are naturally found on grape skins and in the cellar are essential for fermentation. For winegrowers who practice authentic work on their land and in the cellar, ambient yeasts are guaranteed to show off the typicity of terroir.'
      },
      {
        question: 'Pet nat',
        answer: 'A natural sparkling wine or Pet Nat that is made by the ancestral method, is a wine that has been bottled before its fermentation is complete. The carbon dioxide produced from fermentation continues in the bottle and eventually becomes trapped and absorbed by the wine in the form of bubbles.'
      },
      {
        question: 'Traditional method ',
        answer: 'The traditional method is a method of making sparkling wines which consists of a second fermentation in bottles of a still wine after adding a liqueur de tirage (wine and sugar solution). The traditional method of making a sparkling wine is identical to the Champagne method for making champagne.'
      },
      {
        question: 'Brandy (eau-de-vie)',
        answer: 'While wine is the result of a fermentation process, brandy is obtained by fermentation, maceration and distillation of fruits, cereals and even wine.'
      },
      {
        question: 'Specifications',
        answer: 'A specification is a set of rules to which a producer must comply in the case of a controlled appellation (geographical area, type of grape variety, particular vinifications, aging time and more) or certification (organic, biodynamic, etc.)'
      },
    ],
  },
  ordersDeliveries: {
    title: 'Orders and deliveries',
    tabList: {
      commander: 'Commander',
      problems: 'Orders and deliveries',
      livraison: 'Livraison',
    },
    tagLine: 'For any other problem, contact us!',
    commander: [
      {
        question: 'Why do I have to buy by the case?',
        answer: 'According to the law governed by the SAQ, products sold through Private Importation are only available by the case.'
      },
      {
        question: 'Can I order a mixed case?',
        answer: ''
      },
      {
        question: 'How do I order private imports?',
        answer: ''
      },
      {
        question: 'How do I track my order delivered to the SAQ?',
        answer: 'Your SAQ still hasn\'t contacted you after 10 business days of paying the agency fees? Write to us at <a href="mailto:info@boires.ca">info@boires.ca</a>, we\'ll fix that!'
      },
      {
        question: 'The product I want is not available, what should I do?',
        answer: 'Click on the Reserve box on the web page of the product that interests you. Once the product becomes available, we will contact you and you will have a period of 5 days to confirm and submit payment for your order. Beyond 5 days, the product is put back in stock. Orders cannot be confirmed without payment.'
      },
      {
        question: 'Can I reserve future products?',
        answer: 'We do take pre-orders! When the product is available, we will contact you and you will have 5 days to pay the fees before the product is put back in stock.'
      },
      {
        question: 'How can I order products available at the SAQ?',
        answer: 'Go to the SAQ website at <a href="www.saq.com">www.saq.com</a> and select the desired product. You will find the branches that hold the product and the number of bottles available. You will also be able to see which products are available for sale online and for delivery.'
      },
      {
        question: 'Why do I have to buy food to order alcohol in store?',
        answer: 'That\'s the law! <br>For more information, we invite you to read the following article:<br><a href="https://www.legisquebec.gouv.qc.ca/en/document/cs/P-9.1?langCont=en#se:26"> <b>P-9.1</b> - Act respecting liquor permits</a>.'
      },
      {
        question: 'I have dietary restrictions',
        answer: ''
      }
    ],
    problems: [
      {
        question: 'Agency return policy',
        answer: 'Make sure you have your SAQ invoice in hand for a return of defective bottles. The SAQ is responsible for this after-sales service, no refund will be made by Boires. Note that it is not possible to return a bottle for a matter of personal taste.We invite you to call the SAQ Montreal Customer Relations Center: (514) 254-8686 ext. 8048'
      },
      {
        question: 'I have not heard from my SAQ store regarding my order',
        answer: 'Your SAQ still hasn\'t contacted you after 10 business days of paying the agency fees? Write to us at <a href="mailto:info@boires.ca">info@boires.ca</a>, we\'ll fix that!'
      },
      {
        question: 'Return policy Shop',
        answer: 'Exchange only'
      },
    ],
    livraison: [
      {
        question: 'Delivery times',
        answer: ''
      },
      {
        question: 'Can I have my order delivered to my home?',
        answer: ''
      },
      {
        question: 'What are the delivery fees?',
        answer: ''
      },
      {
        question: 'Policy concerning damaged bottles upon delivery (SAQ)',
        answer: ''
      },
    ],
  },
  pricingPolicy: {
    title: 'Pricing policy',
    tabList: {
      pricingPolicy: 'Pricing policy',
    },
    pricingPolicy: [
      {
        question: 'Understanding pricing structure and agency fees',
        answer: 'The prices displayed on our lists include the base price of the bottle and the agency fees, but exclude taxes (GST and QST)'
      },
      {
        question: 'Why is there a price difference between the products in the store and at the cash register?',
        answer: ''
      },
      {
        question: 'What is included in the price displayed?',
        answer: 'The prices displayed on our lists include the base price of the bottle and the agency fees, but exclude taxes (GST and QST)'
      },
    ],
  },
}
